var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6" },
        [
          _c(
            "v-col",
            { staticClass: "pl-0", attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backToPrevPage },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v(_vm._s(_vm.backToLbl) + " "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-7" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _vm.notXs && _vm.displayReadonlyDisclaimer
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "suggestive-class-error",
                              attrs: { color: "#FFDEB8" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "px-2",
                                  attrs: { align: "center" },
                                },
                                [
                                  _c("v-col", { attrs: { cols: "auto" } }, [
                                    _c("img", {
                                      staticClass: "mt-2",
                                      attrs: { src: _vm.ic_orange_warning },
                                    }),
                                  ]),
                                  _c("v-col", { staticClass: "grow ta-l" }, [
                                    _c("label", { staticClass: "error-lbl" }, [
                                      _vm._v(
                                        " This page is set to read-only. "
                                      ),
                                    ]),
                                  ]),
                                  _vm.lg || _vm.xl
                                    ? _c(
                                        "v-col",
                                        { staticClass: "shrink" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                id: "continue-edit-shipment",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.displayReadonlyDisclaimer = false
                                                },
                                              },
                                            },
                                            [_vm._v("OK")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("v-col", { attrs: { cols: "auto" } }, [
                                    _c("img", {
                                      staticClass: "mt-1 hover",
                                      attrs: { src: _vm.ic_red_x },
                                      on: {
                                        click: function ($event) {
                                          _vm.displayReadonlyDisclaimer = false
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v(_vm._s(_vm.pageHeader)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-7" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "5" } },
                    [
                      _c("smart-text-field", {
                        staticClass: "contracts-search",
                        attrs: {
                          placeholder: "Search",
                          search: true,
                          clearable: true,
                          "css-class": { "mt-2": _vm.mdAndUp },
                          "background-color": "white",
                        },
                        on: {
                          clear: _vm.onClear,
                          input: function ($event) {
                            return _vm.applyFilters()
                          },
                          "enter-pressed": function ($event) {
                            return _vm.applyFilters()
                          },
                        },
                        model: {
                          value: _vm.term,
                          callback: function ($$v) {
                            _vm.term = $$v
                          },
                          expression: "term",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          label: "Show Spot Clients",
                          color: "success",
                          "hide-details": "",
                          ripple: false,
                        },
                        on: { change: _vm.showSpotChanged },
                        model: {
                          value: _vm.showSpot,
                          callback: function ($$v) {
                            _vm.showSpot = $$v
                          },
                          expression: "showSpot",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-row", { staticClass: "mt-8" }, [
                _c("label", { staticClass: "afs-clients" }, [
                  _vm._v(
                    _vm._s(_vm.formatWeight(_vm.filteredContracts.length))
                  ),
                ]),
                _c("label", { staticClass: "ml-1 account-lbl" }, [
                  _vm._v("clients"),
                ]),
              ]),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "contracts-grid-wrapper pl-3 br-10" },
                        [
                          _c(
                            "v-card-text",
                            [_c("afs-carrier-clients-grid")],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("smart-paging", {
                attrs: {
                  value: _vm.filteredContracts,
                  showEntryCount: true,
                  pageSize: 25,
                },
                on: { input: _vm.pageChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Clients"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }